import { Column, Link, Row } from "@react-email/components";
import { cn } from "@babackapp/ui/lib/utils";
import { useVariablesValues } from "../../lib/variables-context";
import type { RateOrderBlockProps } from "./types";

const STAR_COUNT = 5;
const STAR_SIZE = 32;

export function RateOrderEmailRenderer({
  block,
  theme,
  isEditor,
}: RateOrderBlockProps & { isEditor?: boolean }) {
  const alignment = block.alignment || "center";
  const { getVariableValue } = useVariablesValues();

  const reviewUrl =
    (getVariableValue("parcel.reviewUrl") as string | null | undefined) ?? "";

  if (!reviewUrl && !isEditor) {
    return null;
  }

  return (
    <Row>
      <Column
        className={cn({
          "text-left": alignment === "left",
          "text-center": alignment === "center",
          "text-right": alignment === "right",
        })}
      >
        {Array.from({ length: STAR_COUNT }, (_, index) => {
          const rating = index + 1;
          const href = reviewUrl
            ? `${reviewUrl}${reviewUrl.includes("?") ? "&" : "?"}rating=${rating}`
            : "#";
          return (
            <Link
              key={rating}
              href={href}
              style={{
                display: "inline-block",
                margin: "0 4px",
                textDecoration: "none",
                lineHeight: 0,
              }}
            >
              <StarIcon color={theme?.primaryColor ?? "#f5b301"} />
            </Link>
          );
        })}
      </Column>
    </Row>
  );
}

function StarIcon({ color }: { color: string }) {
  return (
    <svg
      width={STAR_SIZE}
      height={STAR_SIZE}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2.5l2.9 6.55 7.1.69-5.33 4.88 1.52 6.98L12 18.27l-6.19 3.33 1.52-6.98L2 9.74l7.1-.69L12 2.5z"
        fill={color}
        stroke={color}
        strokeWidth="1"
        strokeLinejoin="round"
      />
    </svg>
  );
}
